import { apiClient } from '@shared/utils/api-client';
import type { HomeTile, CreateHomeTileDto, UpdateHomeTileDto } from '../types';

export const homeTilesApi = {
    getAll: async (): Promise<HomeTile[]> => {
        return apiClient.get<HomeTile[]>('/home-tiles');
    },

    create: async (data: CreateHomeTileDto): Promise<HomeTile> => {
        return apiClient.post<HomeTile>('/home-tiles', data);
    },

    update: async (id: number, data: UpdateHomeTileDto, file?: File): Promise<HomeTile> => {
        if (file) {
            const formData = new FormData();
            if (data.name !== undefined) {
                formData.append('name', data.name);
            }
            if (data.shouldDeleteImage !== undefined) {
                formData.append('shouldDeleteImage', String(data.shouldDeleteImage));
            }
            formData.append('image', file);
            return apiClient.patch<HomeTile>(`/home-tiles/${id}`, formData);
        }
        return apiClient.patch<HomeTile>(`/home-tiles/${id}`, data);
    },

    delete: async (id: number): Promise<void> => {
        return apiClient.delete(`/home-tiles/${id}`);
    },

    updateOrder: async (items: { id: number; order: number }[]): Promise<HomeTile[]> => {
        return apiClient.patch<HomeTile[]>('/home-tiles/order', { items });
    },
};

